module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'succès',
    综合评价: "Évaluation Globale",
    inputNotSame: "Entrée Non Identique",
    exemple: 'Exemple',
    // 选择语言
    popupTitle: 'Sélectionner une langue',
    // 发送
    send: 'Confirmer',
    // 发送邮件
    sendEmail: 'Envoyer un e-mail',
    // 改变语言
    changeLanSes: 'Changement de langue réussi',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',
    // 系统标题
    title: `La voix de l'acheteur`,
    // 系统解释
    details: 'Écouter la voix des acheteurs, fournir des produits et des services de qualité, merci de partager.',
    fileSizeOver: "Le fichier est trop volumineux, seules les images de moins de 10 Mo sont prises en charge.",
    lowTextarea: 'Vos commentaires nous aideront à améliorer continuellement nos produits et services.',
    placeholderOrderNo: "Veuillez saisir le numéro de commande (format : 000-0000000-0000000)",
    "picUploadSuccessText": "Image téléchargée avec succès",
    "picUploadErrorText": "Échec du téléchargement de l'image",
    "orderNotExistText": "La commande n'existe pas",
    "orderInvalidText": "Cette commande est invalide",
    "networkErrorText": "Erreur réseau",
    "orderErrorText": "Erreur de commande",
    // step1
    formBasic: {
        title: `Enregistrez votre garantie maintenant !
Réclamez votre boîte <span style="color:#F40000">mystère</span>, offre exclusive pour les clients existants.`,
        form_name: 'Name',
        form_email: 'Courriel',
        form_order: 'ID de commande',
        form_order_error_placeholder: 'Veuillez saisir le numéro de commande (format : 000-0000000-0000000)',
        order_why: '*Comment trouver votre numéro de commande?',
        order_answer: `*Nous ne partageons pas vos informations personnelles avec qui que ce soit.

Vos informations personnelles sont sécurisées et utilisées uniquement pour l'activation de votre garantie.`,
        btn_text: 'Activer maintenant',
        "form_name_placeholder": "Veuillez entrer votre nom",
        "form_email_placeholder": "Veuillez entrer votre Courriel",
        "form_email_error_placeholder": "Veuillez entrer un Courriel",
        "form_order_placeholder": "Veuillez entrer votre numéro de ID commande"
    },
    // step2
    showGiftCard: {
        title: `Félicitations !</br>
Votre garantie est activée !`,
        text: 'Partagez votre avis et recevez une boîte <span style="color:#F40000">mystère</span>. (Environ 1 minute)',
        gift_card_text: 'Ce que vous pouvez obtenir ',
        btn_text: 'Étape suivante'
    },
    // step3
    star: {
        title: 'Êtes-vous satisfait de ce produit ou de notre service ?',
        text: 'Veuillez attribuer une note en étoiles au produit ci-dessous:',
        star__placeholder: 'Veuillez évaluer toutes les questions avant de soumettre !',
        written: 'Ajouter un avis écrit : <span style="color:#F40000">(Optionnel)</span>',
        written_placeholder: `Qu'avez-vous aimé ? À quoi avez-vous utilisé ce produit ?`,
        btn_text: 'Étape suivante'
    },
    // step4
    ensureEmail: {
        title: `Félicitations!</br>
Vous avez terminé l'enquête.
`,
        text: `Veuillez confirmer l'adresse e-mail, vous recevrez le code cadeau par l'intermédiaire de cette adresse e-mail :
redeem@amazonsurveyzone.com`,
        email_placeholder: `Veuillez confirmer à nouveau l'email !`,
        btn_text: 'Confirmer'
    },
    // step5
    channelSelect: {
        title: `Votre avis compte ! `,
        text: `Partagez vos avis sur les produits sur Amazon pour aider les autres clients à prendre les bonnes décisions.
Rejoignez la communauté de partage d'avis dès maintenant et gagnez des récompenses supplémentaires.`,
        footer: `*A propos du cadeau :</br> 
Pas de frais d'expédition, pas de frais cachés, pas de carte de crédit requise.`,
        btn_text: 'Je le veux'
    },
    // step6
    uploadPic: {
        title: `Veuillez télécharger la capture d'écran de votre commentaire Amazon après l'avoir rédigé.`,
        text: `Une fois votre avis posté avec succès sur Amazon, nous vous contacterons par courrier électronique :
redeem@amazonsurveyzone.com et nous vous remettrons la Boîte Mystère.`,
        add_pic: 'Ajouter des photos',
        add_pic_text: `En général, il faut compter 2 à 3 jours pour que l'avis soit publié sur Amazon.`,
        btn_text: 'Prochaine étape'
    },
    // step7
    cityForm: {
        title: '*Adresse de réception des accessoires : ',
        text: '(Veuillez confirmer votre adresse de livraison, le cadeau sera expédié dans les 3 à 5 jours ouvrables.)',
        form_city: 'Ville',
        form_state: 'État/Région',
        form_postal_code: 'Code postal',
        form_country: 'Pays',
        btn_text: 'Confirmez',
        "form_city_placeholder": "Veuillez entrer votre ville",
        "form_state_placeholder": "Veuillez entrer votre région",
        "form_postal_code_placeholder": "Veuillez entrer votre code postal",
        "form_country_placeholder": "Veuillez entrer votre pays"
    },
    // step7
    paypalForm: {
        title: '*Compte du bénéficiaire de la carte-cadeau : ',
        text: '(Veuillez vérifier attentivement les informations relatives à votre compte)',
        form_paypal: 'Compte Paypal',
        form_ensure_paypal: 'Double confirmation du compte Paypal',
        form_paypal_name: 'Nom',
        btn_text: 'Confirmer',
        "form_paypal_placeholder": "Veuillez entrer votre compte PayPal",
        "form_ensure_paypal_placeholder": "Veuillez confirmer votre compte PayPal",
        "form_paypal_name_placeholder": "Veuillez entrer votre nom PayPal"
    },
    // thanks-all
    thanksAll: {
        "title": "Reconnaissant pour votre contribution !",
        // title_desc1: `Merci d'avoir participé à notre enquête sur les produits ! `,
        // title_desc2: 'projector survey!',
        text: `Vos précieuses opinions nous aideront à améliorer la qualité de nos produits. 
Si vous avez des questions pendant l'utilisation, n'hésitez pas à nous contacter.`
    },
    // thanks
    thanks: {
        "title": "Félicitations !",
        title_desc1: `Votre garantie est activée !
Nous vous remercions pour le temps que vous nous avez consacré.`,
        title_default_paypal_desc1: `Votre garantie est activée !
Nous vous remercions pour le temps que vous nous avez consacré. Votre récompense sera émise dans un délai de 24 à 72 heures.`,
        // title_desc2: 'Thank you very much for your time.',
    },
    // flow
    flow: {
        step1: 'Click to your homepage and click your orders',
        step2: 'Find the order of our store and click it',
        step3: 'Find the page of “Order info” and click “View order details”',
        step4: 'Order # is your order number, and you can copy the number and fill in our website',
    }
}
